import Http from 'axios'
import {VERSIONED_API_URL} from '../../config/config'

function initialState() {
    return {
        all: [],
        query: '',
        exportUrl: '',
        filter: '',
        loading: false,
        document_types: [],
        document_type: {
            id: null,
            name: '',
            remarks:''
        },
        modelName: 'document-types'
    }
}

const getters = {
    all: state => state.all,
    loading: state => state.loading,
    serverPagination: state => state.serverPagination,
    document_type: state => state.document_type,
    filter: state => state.filter,
    query: state => state.query,
    totalNumber: state => state.totalNumber,
    exportUrl: state => {
        let pagination = state.serverPagination;
        let query = '?page=' + pagination.page + '&table_data&rowsPerPage=' + pagination.itemsPerPage + '&sortBy=' + pagination.sortBy + '&descending=' + pagination.descending;
        if (state.query)
            query = query + state.query;
        return `${VERSIONED_API_URL}/${state.modelName}/export/${query}`
    }
};


const actions = {
    fetchAll({state,commit}){
        Http.get(`${VERSIONED_API_URL}/${state.modelName}`).then((response)=>{
            commit('setAll',response.data.data)
        })
    },
    resetDocumentType({commit}) {
        let initial_state = initialState();
        commit('setModel', initial_state.document_type)
    },
    show({state, commit}, id) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {

            Http.get(`${VERSIONED_API_URL}/${state.modelName}/${id}`).then((response) => {
                commit('setLoading', false)
                let data = response.data.data;
                commit('setModel', data)
                resolve(true)
            }).catch((error) => {
                reject(error)
            })
        })
    },
}


const mutations = {
    setAll(state, items) {
        state.all = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setPermission(state, permission) {
        state.permission = permission
    },
    setServerPagination(state, item) {
        console.log(item)
        state.serverPagination = item
    },
    setTotalNumber(state, item) {
        state.totalNumber = item
    },
    setModel(state, item) {
        state.document_type = item;
    },
    setQuery(state, query) {
        state.query = query
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setFilter(state, item) {
        state.filter = item
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
